import React, { useMemo } from 'react';
import { Text, View, ScrollView } from 'react-native';

import { t } from 'Locale';
import { Button, Hr, Icon, ModalHeader } from 'LocalGluons';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Device } from 'DeviceUtils';
import defaultStyles from './RedirectScene.jss';
import getVoyoStoreParameters, { PLATFORM_TYPE } from './getVoyoStoreParameters';
import { openInStore } from './getStoreParameters';

interface RedirectSceneProps {
    close: () => void;
    thirdPartyApp?: PLATFORM_TYPE;
    deeplinkUrl?: `https://${string}`;
}

const RedirectScene = ({
    close,
    thirdPartyApp,
    deeplinkUrl
}: RedirectSceneProps): React.ReactElement => {
    const { appName, appStoreId, playStoreId, appStoreLocale } = useMemo(
        () => getVoyoStoreParameters(thirdPartyApp),
        [thirdPartyApp]
    );

    return (
        <SafeAreaView style={defaultStyles.container}>
            <ModalHeader
                style={{
                    iconContainer: defaultStyles.iconCloseContainer
                }}
                onPress={close}
            />
            <ScrollView contentContainerStyle={defaultStyles.scrollContainer}>
                <View style={defaultStyles.logoBox}>
                    <Icon style={defaultStyles.logo} name="voyo_logo" />
                </View>

                <Text style={defaultStyles.title}>{t('PARTNER.VOYO.NO_APP_TITLE_MOBILES')}</Text>
                <Hr style={defaultStyles.hrStyle} />
                <Text style={defaultStyles.subtitle}>
                    {t('PARTNER.VOYO.APP_STORE_TEXT_MOBILES')}
                </Text>

                <View style={defaultStyles.buttonContainer}>
                    <Button
                        style={{
                            button: defaultStyles.buttonContinue,
                            text: defaultStyles.textContinue
                        }}
                        title={t('PARTNER.VOYO.APP_STORE_OPEN_STORE_BTN')}
                        onPress={() =>
                            openInStore({
                                appName,
                                appStoreId,
                                playStoreId,
                                appStoreLocale
                            })
                        }
                        isSecondary={!Device.isWeb}
                    />

                    <Button
                        onPress={() => {
                            openInStore({
                                appName,
                                appStoreId,
                                playStoreId,
                                appStoreLocale,
                                deeplinkToWeb: deeplinkUrl
                            });
                        }}
                        style={{ button: defaultStyles.button }}
                        title={t('PARTNER.VOYO.WATCH_ON_WEB_BTN')}
                        isSecondary={Device.isWeb}
                    />
                </View>
            </ScrollView>
        </SafeAreaView>
    );
};

export default RedirectScene;
